export default __webpack_public_path__ + "static/media/qrCode.c0ae1dd2.svg";